 

 
<template>
  <!--expand-on-hover-->
  <v-navigation-drawer
    v-model="drawer"
    :rail="rail"
   
    permanent
    style="  padding:0px!important;"
    color="background"


 
  >
   
 
    <!-- Navigation -->
    <v-list density="compact" nav style=" " class="">


 
        <!-- Dashboard -->

        
     
        <div class="sidebar-brand" :class="{ 'sidebar-brand--rail': rail }">
          <img class="sidebar-brand__logo" :src="logo" alt="Quotastic" />
          <span v-if="!rail" class="sidebar-brand__text">Quotastic</span>
        </div>

        <v-tooltip
          v-for="item in mainNavItems"
          :key="item.label"
          :text="item.label"
          location="end"
          open-delay="120"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              :to="item.to"
              :exact="item.exact"
              :active="isMainNavItemActive(item)"
              router
            >
              <template #prepend>
                <v-icon class="nav-bottom-btn-icon mr-2" size="19">
                  {{ item.icon }}
                </v-icon>
              </template>
              <v-list-item-title class="side-nav-title">
                {{ item.label.toUpperCase() }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-tooltip>
 
    </v-list>


    <template v-slot:append>


      <v-list density="compact" class="mb-0">


        <v-list-item @click="toggleTheme">
          <template #prepend>
            <v-icon class="nav-bottom-btn-icon mr-2" size="19">mdi-brightness-4</v-icon>
          </template>
          <v-list-item-title class="side-nav-title">
            {{ theme.global.name.value === 'dark' ? 'LIGHT MODE' : 'DARK MODE' }}
          </v-list-item-title>
        </v-list-item>

        <!-- Build
        <v-tooltip
          :text="rail ? 'Open sidebar' : 'Close sidebar'"
          location="end"
          open-delay="120"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              @click="toggleRail"
            >
                <template #prepend>
                  <v-icon style=" opacity:0.7; " class="nav-bottom-btn-icon mr-2" size="19" > mdi-arrow-expand-horizontal</v-icon>
                </template>
                <v-list-item-title class="side-nav-title">
                  {{ rail ? 'OPEN SIDEBAR' : 'CLOSE SIDEBAR' }}
                </v-list-item-title>
            </v-list-item>
          </template>
        </v-tooltip> -->
 
        <!-- Logout -->
        <v-tooltip
          text="Logout"
          location="end"
          open-delay="120"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              @click="onSignOut"
              class="logout-btn"
            >
                    <template #prepend>
                      <v-icon class="nav-bottom-btn-icon mr-2" size="19">mdi-power</v-icon>
                    </template>
                    <v-list-item-title class="side-nav-title">LOGOUT</v-list-item-title>
            </v-list-item>
          </template>
        </v-tooltip>


      </v-list>
    </template>
  </v-navigation-drawer>


  <!-- ADMIN -->
  <v-navigation-drawer
    v-if="route.path.includes('/admin')"
    class="cms-drawer"
    width="230"
  >
 

    <v-list class="mt-3 cms-drawer__list" density="compact" nav>
      <v-list-item
        v-for="item in adminItems"
        :key="item.label"
        class="cms-drawer__item"
        :class="{ 'settings-item-active': selectedAdmin === item.value }"
        :value="item.value"
        link
        @click="selectAdmin(item.value)"
      >
        <template #prepend>
          <span class="cms-drawer__item-icon">
            <v-icon size="19">{{ item.icon }}</v-icon>
          </span>
        </template>

        <v-list-item-title class="cms-drawer__item-title">
          {{ item.label }}
        </v-list-item-title>
        <v-list-item-subtitle class="cms-drawer__item-subtitle">
          {{ item.description }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>



































 


  <!-- CMS -->
  <v-navigation-drawer
    v-if="route.path.includes('/cms')"
    class="cms-drawer"
    width="230"
  >


    <v-list class="mt-3 cms-drawer__list" density="compact" nav>
      <v-list-item
        v-for="item in mainCmsItems"
        :key="item.label"
        :to="item.to"
        :active="isCmsItemActive(item)"
        class="cms-drawer__item"
        router
      >
        <template #prepend>
          <span class="cms-drawer__item-icon">
            <v-icon size="19">{{ item.icon }}</v-icon>
          </span>
        </template>

        <v-list-item-title class="cms-drawer__item-title">
          {{ item.label }}
        </v-list-item-title>
        <v-list-item-subtitle class="cms-drawer__item-subtitle">
          {{ item.description }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <!-- CRM -->
  <v-navigation-drawer
    v-if="route.path.includes('/crm')"
    class="cms-drawer"
    width="230"
  >

    <v-list class="mt-3 cms-drawer__list" density="compact" nav>
      <v-list-item
        v-for="item in mainCrmItems"
        :key="item.label"
        :to="item.to"
        class="cms-drawer__item"
        router
      >
        <template #prepend>
          <span class="cms-drawer__item-icon">
            <v-icon size="19">{{ item.icon }}</v-icon>
          </span>
        </template>

        <v-list-item-title class="cms-drawer__item-title">
          {{ item.label }}
        </v-list-item-title>
        <v-list-item-subtitle class="cms-drawer__item-subtitle">
          {{ item.description }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <!-- MARKETING -->
  <v-navigation-drawer
    v-if="route.path.includes('/marketing')"
    class="cms-drawer"
    width="230"
  >

    <v-list class="mt-3 cms-drawer__list" density="compact" nav>
      <v-list-item
        v-for="item in mainMarketingItems"
        :key="item.label"
        :to="item.to"
        class="cms-drawer__item"
        router
      >
        <template #prepend>
          <span class="cms-drawer__item-icon">
            <v-icon size="19">{{ item.icon }}</v-icon>
          </span>
        </template>

        <v-list-item-title class="cms-drawer__item-title">
          {{ item.label }}
        </v-list-item-title>
        <v-list-item-subtitle class="cms-drawer__item-subtitle">
          {{ item.description }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>



  <!-- SETTINGS -->
  <v-navigation-drawer
    v-if="route.path.includes('/settings')"
    class="cms-drawer"
    width="230"
  >
 

    <v-list class="mt-3 cms-drawer__list" density="compact" 
    nav>
      <v-list-item
        v-for="item in mainSettingItems"
        :key="item.label"
        class="cms-drawer__item"
        :class="{ 'settings-item-active': selectedSetting === item.value }"
        :value="item.value"
        link
        @click="selectSetting(item.value)"
      >
        <template #prepend>
          <span class="cms-drawer__item-icon">
            <v-icon size="19">{{ item.icon }}</v-icon>
          </span>
        </template>

        <v-list-item-title class="cms-drawer__item-title">
          {{ item.label }}
        </v-list-item-title>
        <v-list-item-subtitle class="cms-drawer__item-subtitle">
          {{ item.description }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>










  <!--



  <v-navigation-drawer  v-if="route.path === '/settings'" >
        <v-list>
          <v-list-item to="/" router>
              <v-list-item-title class="side-nav-title">About</v-list-item-title>
          </v-list-item>
          <v-list-item to="/" router>
              <v-list-item-title class="side-nav-title">Contact</v-list-item-title>
          </v-list-item>
          <v-list-item to="/" router>
              <v-list-item-title class="side-nav-title">Bug Report</v-list-item-title>
          </v-list-item>
        </v-list>
  </v-navigation-drawer>
  -->

 
</template>






































<script setup>
import { ref, computed } from "vue"
import logo from '@/assets/logo.png'

import { useRoute } from 'vue-router'
 
import { isAdmin, isDevUser } from '@/stores/appConfig'

const route = useRoute()

// All CMS/CRM/Marketing/etc. routes are flat top-level entries in
// router/index.js (no `children:` nesting), so Vue Router's own :to active
// matching only ever considers a nav item "active" when the route matches
// that item's exact record — e.g. the "CMS" rail tile (pointing at /cms)
// never lights up while actually on /cms/builder3 or /cms/domain, since
// those are separate route records, not descendants of /cms. This derives
// each item's section root (first path segment) and does a prefix match
// instead, so the rail tile stays highlighted anywhere in its section.
function sectionPrefix(to) {
  const segment = to.split('/')[1]
  return segment ? `/${segment}` : '/'
}

function isMainNavItemActive(item) {
  if (item.exact) return route.path === item.to
  const prefix = sectionPrefix(item.to)
  return route.path === prefix || route.path.startsWith(`${prefix}/`)
}

// The CMS drawer's own sub-items are mostly on distinct paths where the
// default :to matching works fine, except Site Builder (AI) and Site
// Builder (Custom Code) — same /cms/builder3 route, split only by a
// ?mode=custom query param. Vue Router's default (non-exact) active
// matching ignores query strings entirely, so without this both items would
// show active at once whenever the path matches, regardless of which mode
// is actually open.
function isCmsItemActive(item) {
  const [itemPath, itemQuery] = item.to.split('?')
  if (route.path !== itemPath) return false
  const itemMode = itemQuery ? new URLSearchParams(itemQuery).get('mode') : null
  return (route.query.mode || null) === itemMode
}

const allNavItems = [
  { label: 'Dashboard', icon: 'mdi-view-dashboard-outline', to: '/',        exact: true },
  { label: 'CRM',       icon: 'mdi-account-group-outline',  to: '/crm/leads', contractorOnly: true },
  { label: 'Quotes',    icon: 'mdi-currency-usd',           to: '/quote',  devOnly: true, contractorOnly: true },
  { label: 'Jobs',      icon: 'mdi-briefcase-outline',      to: '/jobs',   contractorOnly: true },
  { label: 'CMS',       icon: 'mdi-web',                    to: '/cms',        contractorOnly: true },
  { label: 'Marketing', icon: 'mdi-bullhorn-outline',       to: '/marketing/digital', devOnly: true, contractorOnly: true },
  { label: 'Settings',  icon: 'mdi-cog-outline',            to: '/settings', exact: true, contractorOnly: true },
  { label: 'Admin',     icon: 'mdi-security',               to: '/admin',    exact: true, adminOnly: true },
]

const mainNavItems = computed(() =>
  allNavItems.filter(item => {
    if (item.devOnly && !isDevUser.value) return false
    if (item.adminOnly && !isAdmin.value) return false
    if (item.contractorOnly && isAdmin.value) return false

    return true
  })
)

const cmsItems = [
  {
    label: 'Overview',
    description: 'CMS home',
    icon: 'mdi-view-dashboard-outline',
    to: '/cms',
  },
  {
    label: 'Domain Management',
    description: 'DNS and publishing',
    icon: 'mdi-earth',
    to: '/cms/domain',
  },
  {
    label: 'Site Builder (Template)',
    description: 'Edit pages',
    icon: 'mdi-view-dashboard-edit-outline',
    to: '/cms/builder',
  },
  {
    label: 'Site Builder (AI)',
    description: 'Edit pages',
    icon: 'mdi-creation',
    to: '/cms/builder3',
  },
  {
    label: 'Site Builder (Custom Code)',
    description: 'Bring your own HTML',
    icon: 'mdi-code-tags',
    to: '/cms/builder3?mode=custom',
  },
  {
    label: 'Email',
    description: 'Inbox setup',
    icon: 'mdi-email-outline',
    to: '/cms/email',
  },
]

const mainCmsItems = computed(() =>
  cmsItems.filter(item => {
    if (item.devOnly && !isDevUser.value) return false


    return true
  })
)

const crmItems = [
  { label: 'Leads', description: 'Inbox and pipeline', icon: 'mdi-message-outline', to: '/crm/leads' },
  { label: 'Contacts', description: 'All contacts and customers', icon: 'mdi-contacts-outline', to: '/crm/contacts' },
]

const mainCrmItems = computed(() => crmItems)

const marketingItems = [
  { label: 'Digital Marketing', description: 'Ad accounts and lead sources', icon: 'mdi-google-ads', to: '/marketing/digital' },
  { label: 'Physical Marketing', description: 'Design print materials', icon: 'mdi-card-account-mail-outline', to: '/marketing/physical' },
  { label: 'Reputation', description: 'Review requests', icon: 'mdi-star-outline', to: '/marketing/reputation' },
  { label: 'Campaigns', description: 'Email past contacts', icon: 'mdi-email-multiple-outline', to: '/marketing/campaigns' },
]

const mainMarketingItems = computed(() => marketingItems)





import { selectedAdmin, selectedSetting } from "@/stores/appConfig"
const settingItems = [

  {
    label: 'Team / Org Profile',
    description: "Manage your organization's profile",
    icon: 'mdi-account-outline',
    value: '/settings/company',
  },
  {
    label: 'Person Profile',
    description: 'Manage your profile',
    icon: 'mdi-account-outline',
    value: '/settings/profile',
  },

  {
    label: 'Team',
    description: 'Manage team members',
    icon: 'mdi-account-group-outline',
    value: '/settings/team',
    devOnly: true
  },

  {
    label: 'Billing',
    description: 'Payment methods and invoices',
    icon: 'mdi-credit-card-outline',
    value: '/settings/billing',
    devOnly: true
  },
]

const mainSettingItems = computed(() =>
  settingItems.filter(item => {
    if (item.devOnly && !isDevUser.value) return false
 

    return true
  })
)



function selectSetting(value) {
  selectedSetting.value = value
}

const adminItems = [
  {
    label: 'Users',
    description: 'Owners & team members',
    icon: 'mdi-account-group-outline',
    value: '/admin/users',
  },
  {
    label: 'Companies',
    description: 'Search company records',
    icon: 'mdi-domain',
    value: '/admin/companies',
  },
  {
    label: 'Admins',
    description: 'Platform administrators',
    icon: 'mdi-shield-account-outline',
    value: '/admin/admins',
  },
  {
    label: 'Logs',
    description: 'User activity history',
    icon: 'mdi-history',
    value: '/admin/logs',
  },
  {
    label: 'CMS',
    description: 'Template Builder',
    icon: 'mdi-palette',
    value: '/admin/templates',
  },
  {
    label: 'Database',
    description: 'Browse all tables',
    icon: 'mdi-database-outline',
    value: '/admin/database',
  },
  {
    label: 'Print Templates',
    description: 'Physical Marketing materials',
    icon: 'mdi-card-account-mail-outline',
    value: '/admin/print-templates',
  },

]

function selectAdmin(value) {
  selectedAdmin.value = value
}








const drawer = ref(true)
const rail = ref(true)










defineProps({
  onSignOut: {
    type: Function,
    required: true
  },
  userName: { type: String, default: '' }
})
















import { useTheme } from 'vuetify';
import { watch } from 'vue';


const theme = useTheme();






const toggleTheme = () => {
  theme.global.name.value =
    theme.global.name.value === 'dark' ? 'light' : 'dark';
};
watch(
  () => theme.global.name.value,
  v => localStorage.setItem('theme', v)
);
theme.global.name.value = localStorage.getItem('theme') || 'light';




/*

const toggleRail = () => {
 
  rail.value = !rail.value;
  localStorage.setItem('rail', rail.value);
 


  //@click="rail = false"
  //theme.global.name.value =
  //    theme.global.name.value === 'dark' ? 'light' : 'dark';
};

rail.value = localStorage.getItem('rail') === 'true';
*/


</script>


























<style scoped>
:deep(.v-navigation-drawer) {
  height: 100vh; /* force full height */
}
.side-nav-title{
   
    text-align: left!important;
    padding-left:0!important;
    font-size: 9px!important;
    font-weight: 500!important;


}


.logout-btn {
 
 
 
}
.nav-bottom-btn-icon, .side-nav-title{
  color:grey
}

.sidebar-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 48px;
  padding: 10px 14px 12px;
}

.sidebar-brand--rail {
  padding-left: 8px;
  padding-right: 8px;
}

.sidebar-brand__logo {
  display: block;
  width: 31px;
  height: 31px;
  flex: 0 0 30px;
  object-fit: contain;
}

.sidebar-brand--rail .sidebar-brand__logo {
  width: 25px;
  height: 25px;
  flex-basis: 34px;
}

.sidebar-brand__text {
  color: var(--text-primary)!important;
  font-size: 21px;
  font-weight: 600;
  line-height: 1;
 
  white-space: nowrap;
}

.cms-drawer {
  border-left: 1px solid var(--border-subtle);
  background: var(--bg-app)!important;
}

.cms-drawer__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 12px;
  padding: 12px;
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  background: var(--surface);
}

.cms-drawer__header-icon,
.cms-drawer__item-icon {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
 
  color: var(--text-secondary); 
}

.cms-drawer__header strong {
  display: block;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.1;
}

.cms-drawer__header span:not(.cms-drawer__header-icon) {
  display: block;
  margin-top: 3px;
  color: var(--text-secondary);
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
}

.cms-drawer__list {
  display: grid;
  gap: 8px;
  padding: 0 12px 12px!important;
}

:deep(.cms-drawer__item.v-list-item) {
  min-height: 64px;
  padding: 8px 10px!important;
  border: 1px solid var(--border-subtle);
  border-radius: 8px!important;
  background: var(--surface);
  color: var(--text-primary);
}

:deep(.cms-drawer__item.v-list-item:hover) {
  border-color: #f26e2e;
  background: #fff;
}

:deep(.cms-drawer__item.v-list-item--active) {
  border-color: #f26e2e;
  background: #fff;
}

:deep(.cms-drawer__item.settings-item-active) {
  border-color: #f26e2e;
  background: #fff;
}

/* Vuetify layers its own semi-transparent "activated" state overlay on top
   of the background above (using the active item's orange text color at low
   opacity), which is what turns the intended pure white into the light
   peach (#fff7f2) the comment below refers to. Zeroing the overlay here
   keeps the background actually white instead of tinted. */
:deep(.cms-drawer__item.v-list-item--active .v-list-item__overlay),
:deep(.cms-drawer__item.settings-item-active .v-list-item__overlay) {
  opacity: 0;
}

:deep(.cms-drawer__item.v-list-item--active .cms-drawer__item-icon) {
  color: #f26e2e;
    border-color: #f26e2e;
  background: #fff;
}

:deep(.cms-drawer__item.settings-item-active .cms-drawer__item-icon) {
  color: #f26e2e;
    border-color: #f26e2e;
  background: #fff;
}

/* The active background above (#fff7f2) is a fixed light peach tied to the
   orange brand accent, not theme-reactive — so its text can't use
   var(--text-primary)/var(--text-secondary) either, or it goes near-white
   on a light background in dark mode. Pin it to a fixed dark pair instead. */
:deep(.cms-drawer__item.v-list-item--active .cms-drawer__item-title),
:deep(.cms-drawer__item.settings-item-active .cms-drawer__item-title) {
  color: #17231f !important;
}

:deep(.cms-drawer__item.v-list-item--active .cms-drawer__item-subtitle),
:deep(.cms-drawer__item.settings-item-active .cms-drawer__item-subtitle) {
  color: #6b5a4f !important;
}

:deep(.cms-drawer__item .v-list-item__prepend) {
  align-self: center;
  margin-right: 10px;
}

:deep(.cms-drawer__item .v-list-item__spacer) {
  width: 0;
}

.cms-drawer__item-title {
  color: var(--text-primary);
  font-size: 12px!important;
  font-weight: 800!important;
  line-height: 1.2!important;
  text-align: left!important;
}

.cms-drawer__item-subtitle {
  margin-top: 3px;
  color: var(--text-secondary)!important;
  font-size: 10px!important;
  font-weight: 500!important;
  line-height: 1.2!important;
  opacity: 1!important;
  text-align: left!important;
}
</style>
